import addStartupScript from './events/addStartupScript';
import setupLazyImages from './media/lazyImage';

addStartupScript(() => setupLazyImages());
